// The crew app's service worker (STAGE_5 5.1), built by vite-plugin-pwa: the bundle
// precached, API reads answered from the last copy when the network is gone. Only the
// crew screens register it, so the desk PCs never run one. A new version waits for the
// crew to tap "Update" - reloading by itself could land in the middle of a call.

import { useEffect, useState } from 'react';

/** Same name as the runtime cache in vite.config.ts. */
export const API_CACHE = 'sos-api';

type Update = (reload?: boolean) => Promise<void>;

let registered: Promise<Update | null> | null = null;
const waitingListeners = new Set<() => void>();
let waiting = false;

function register(): Promise<Update | null> {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return Promise.resolve(null);
  registered ??= import('virtual:pwa-register').then(({ registerSW }) =>
    registerSW({
      onNeedRefresh() {
        waiting = true;
        waitingListeners.forEach((listener) => {
          listener();
        });
      },
    }),
  );
  return registered;
}

/** Registers the worker once; tells whether a new version waits, and installs it. */
export function useServiceWorker() {
  const [needsUpdate, setNeedsUpdate] = useState(waiting);
  useEffect(() => {
    const listener = () => {
      setNeedsUpdate(true);
    };
    waitingListeners.add(listener);
    void register();
    return () => {
      waitingListeners.delete(listener);
    };
  }, []);
  const update = () => {
    void register().then((apply) => apply?.(true));
  };
  return { needsUpdate, update };
}

/** Forget the API answers kept for offline use: at sign-out and at a role switch, so
 * the next person on the tablet, or the other role, never reads them. */
export async function clearApiCache(): Promise<void> {
  try {
    if ('caches' in window) await window.caches.delete(API_CACHE);
  } catch {
    // Nothing kept, or storage refused: nothing to forget.
  }
}
